import React from 'react';
import Countdown from '../../../../components/Countdown/Countdown';
import ImageSlider from '../../../../components/ImageSlider/ImageSlider';
import LeadForm from '../../../../components/LeadForm/LeadForm';
import { useStateContext } from '../../../../context/ContextProvider';
import LanguageNavigate from '../../../../components/Language/LanguageNavigate';
import Footer from '../../../../components/Footer/Footer';
import NoiseBackground from '../../../../components/Background/NoiseBackground';
import Height15 from '../../../../components/Gap/Height';
import HikalLeadForm from '../../../../components/LeadForm/HikalLeadForm';

function BinghattiCircleHikal({
    language
}) {
    const {
        langs,
        langCode,
        userInfo
    } = useStateContext();

    const currentLang = langs.find((lang) => lang.code === langCode);

    const isUAE = userInfo?.countryName === 'United Arab Emirates';
    const isSaudia = userInfo?.countryName === 'Saudi Arabia';
    // const isSaudia = true;


    const images = [
        "/assets/images/projects/binghatti-circle/1.webp",
        "/assets/images/projects/binghatti-circle/2.webp",
        "/assets/images/projects/binghatti-circle/3.webp",
        "/assets/images/projects/binghatti-circle/4.webp"
    ];

    const poster = "/assets/images/projects/binghatti-circle/1.webp";
    const webm = "/assets/images/projects/binghatti-circle/hero.webm";
    const mp4 = "/assets/images/projects/binghatti-circle/hero.mp4";

    return (
        <>
            <div>
                <NoiseBackground />

                {/* LANGUAGE */}
                <LanguageNavigate
                    redirect={language === "ar"
                        ? "/projects/binghatti/circle"
                        : "/projects/binghatti/circle/ar"
                    }
                />
                {/* LIMITED TIME OFFER */}
                <div className="padding-container my-5 py-5">
                    <Countdown />
                </div>

                <Height15 />

                {/* HEADING */}
                <div className="padding-container text-center my-5 py-5">
                    {language === "ar"
                        ? (
                            <h1 className="text-center px-2 my-1 text-xl">
                                {isSaudia ? (
                                    <>
                                        لأول مرة في قلب دبي
                                        <br />
                                        تملك شقتك في أطول برج سكني
                                        <br />
                                        تبعد
                                        <span className="text-2xl bounce-text secondary-text">
                                            9
                                        </span>
                                        دقائق عن المارينا
                                        <br />
                                        بأقساط شهرية
                                        <span className="text-2xl bounce-text secondary-text">
                                            2348
                                        </span>
                                        ريال
                                        <br />
                                        وبمقدم
                                        <span className="text-2xl bounce-text secondary-text">
                                            70
                                        </span>
                                        الف ريال
                                        <br />
                                        والباقي أقساط ميسرة لحد الإستلام
                                        <br />
                                        من المطور مباشرة وبدون فوائد بنكية
                                    </>
                                ) : (
                                    <>
                                        لأول مرة في قلب دبي
                                        <br />
                                        تملك شقتك في أطول برج سكني
                                        <br />
                                        تبعد
                                        <span className="text-2xl bounce-text secondary-text">
                                            9
                                        </span>
                                        دقائق عن المارينا
                                        <br />
                                        بأقساط شهرية
                                        <span className="text-2xl bounce-text secondary-text">
                                            2300
                                        </span>
                                        درهم فقط
                                        <br />
                                        وبمقدم
                                        <span className="text-2xl bounce-text secondary-text">
                                            69
                                        </span>
                                        الف درهم
                                        <br />
                                        والباقي أقساط ميسرة لحد الإستلام
                                        <br />
                                        من المطور مباشرة وبدون فوائد بنكية
                                    </>
                                )}
                            </h1>
                        ) : (
                            <>
                                <h1 className="text-center px-2 my-1 pb-3 text-xl">
                                    {isSaudia ? (
                                        <>
                                            Your chance before the official launch!
                                            <br />
                                            Your apartment just
                                            <span className="text-2xl bounce-text secondary-text">
                                                9
                                            </span>
                                            minutes away from the Marina,
                                            <br />
                                            with a down payment of only
                                            <span className="text-2xl bounce-text secondary-text">
                                                SAR 70,000
                                            </span>
                                            <br />
                                            and monthly installments of
                                            <span className="text-2xl bounce-text secondary-text">
                                                SAR 2,348
                                            </span>
                                        </>
                                    ) : (
                                        <>
                                            Your chance before the official launch!
                                            <br />
                                            Your apartment just
                                            <span className="text-2xl bounce-text secondary-text">
                                                9
                                            </span>
                                            minutes away from the Marina,
                                            <br />
                                            with a down payment of only
                                            <span className="text-2xl bounce-text secondary-text">
                                                AED 69,000
                                            </span>
                                            <br />
                                            and monthly installments of
                                            <span className="text-2xl bounce-text secondary-text">
                                                AED 2,300
                                            </span>
                                        </>
                                    )}
                                </h1>
                                {/* <h1 className="text-center px-2 my-1 pb-3 text-xl">
                                    <span className="font-bold primary-text">
                                        Limited-time offer
                                    </span>
                                    : Reserve your unit now and get a free furnishing voucher!
                                </h1>
                                <h1 className="text-center px-2 my-1 pb-3 text-xl">
                                    Register today to secure your dream home&nbsp;
                                    <span className="font-bold primary-text">
                                        before the official launch
                                    </span>!
                                </h1> */}
                            </>
                        )
                    }
                </div>
            </div >
            {/* IMAGES */}
            <div className="flex w-full justify-center mb-5 pb-5">
                <video
                    autoPlay={true}
                    loop={true}
                    muted={true}
                    playsInline={true}
                    preload="auto"
                    poster={poster}
                    width="350"
                    height="350"
                    className={`max-w-[350px] rounded-3xl`}
                >
                    <source src={webm} type="video/webm" />
                    <source src={mp4} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            </div>

            {/* < ImageSlider images={images} /> */}
            <div className="padding-container text-center my-5 py-5">
                {language === "ar"
                    ? isSaudia ? (
                        <p className="px-2 my-1">
                            فرصتك قبل الطرح
                            <br />
                            من أسرع مطور بالإمارات
                            <br />
                            سجل بياناتك لإرسال التفاصيل
                        </p>
                    ) : (
                        <p className="px-2 my-1">
                            فرصتك قبل الطرح
                            <br />
                            من أسرع مطور بالإمارات
                            <br />
                            سجل بياناتك لإرسال التفاصيل
                        </p>
                    )
                    : isSaudia ? (
                        <p className="px-2 my-1">
                            This opportunity is for a limited time only.
                            <br />
                            Submit your details and we’ll send you all the information.
                        </p>
                    ) : (
                        <p className="px-2 my-1">
                            This opportunity is for a limited time only.
                            <br />
                            Submit your details and we’ll send you all the information.
                        </p>
                    )
                }
            </div>

            <div className="p-5 my-5">
                {/* LEAD FORM */}
                <HikalLeadForm
                    developer="Binghatti"
                    project="Al Jaddaf"
                    leadType="Apartment"
                    language={language === "ar" ? "Arabic" : "English"}
                    enquiries={["Studio", "1 Bedroom", "2 Bedrooms", "3 Bedrooms"]}
                    askEmail={false}
                />
            </div>
            <Footer />
        </>
    );
}

export default BinghattiCircleHikal;
